import { render, staticRenderFns } from "./ImmediateDiscountInfo.vue?vue&type=template&id=c86f4ce4&"
import script from "./ImmediateDiscountInfo.vue?vue&type=script&lang=ts&"
export * from "./ImmediateDiscountInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports